import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import React, { useState } from 'react';
import { Button, Card, Col, Form, Modal, Row, Spinner, Badge } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import FalconCloseButton from 'components/common/FalconCloseButton';
import IconButton from 'components/common/IconButton';
import PageHeader from 'components/common/PageHeader';
import SoftBadge from 'components/common/SoftBadge';
import useToken from 'hooks/useToken';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useToast } from 'context/providers/ToastProvider';


const PlanesFacturacionElSalvador = () => {

    const columnsNITs = [
        {
            accessor: 'none',
            Header: '',
            Cell: rowData => {
                const { idElSalvadorFacturacionExistencias } = rowData.row.original;
                return (
                    <>
                        <Row className="flex-start-center">
                            <Col xs="auto" >
                                <Button
                                    variant="light"
                                    size="sm"
                                    className="border-300 text-600"
                                    onClick={() => { reset(); ObtenerNITByID(idElSalvadorFacturacionExistencias) }}
                                >
                                    <FontAwesomeIcon icon="edit" />
                                </Button>&nbsp;
                                <Button
                                    variant="light"
                                    size="sm"
                                    className="border-300 text-600"
                                    onClick={() => { reset(); ObtenerPlanesDocumentos(idElSalvadorFacturacionExistencias) }}
                                >
                                    <FontAwesomeIcon icon="plus" />
                                </Button>
                            </Col>
                        </Row>
                    </>
                );
            }
        },
        {
            accessor: 'idElSalvadorFacturacionExistencias',
            Header: 'ID',
            Cell: rowData => {
                const { idElSalvadorFacturacionExistencias } = rowData.row.original;
                return (<span>{idElSalvadorFacturacionExistencias}</span>)
            }
        },
        {
            accessor: 'bIsActive',
            Header: 'Estatus',
            headerProps: { className: 'pe-1' },
            cellProps: {
                className: 'py-2'
            },
            Cell: rowData => {
                const { bIsActive } = rowData.row.original;
                return bIsActive ? (<SoftBadge pill bg='success' className='me-2'>Activo</SoftBadge>) : <><SoftBadge pill bg='danger' className='me-2'>No activo</SoftBadge></>;
            }
        },
        {
            accessor: 'vNombre',
            Header: 'Nombre',
            headerProps: { className: 'pe-1' },
            cellProps: {
                className: 'py-2'
            },
            Cell: rowData => {
                const { vNombre } = rowData.row.original;
                return (<span >{vNombre}</span>);
            }
        },
        {
            accessor: 'vNIT',
            Header: 'NIT',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { vNIT } = rowData.row.original;
                return (<span> {vNIT}</span>)
            }
        },
        {
            accessor: 'vUsuario',
            Header: 'Usuario',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { vUsuario } = rowData.row.original;
                return (<span> {vUsuario}</span>)
            }
        },
        {
            accessor: 'vPassword',
            Header: 'Contrasena',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { vPassword } = rowData.row.original;
                return (<span> {btoa(vPassword)}</span>)
            }
        },
        {
            accessor: 'iExistencia',
            Header: 'Existencia',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { iExistencia } = rowData.row.original;
                return (iExistencia < 0 ? <SoftBadge pill bg='success' className='me-2'>Ilimitado</SoftBadge> : <span> {(iExistencia == 0 ? <SoftBadge pill bg='danger' className='me-2'>Sin Existencia</SoftBadge> : iExistencia)}</span>)
            }
        },
        {
            accessor: 'dFechaExpiracion',
            Header: 'Fech. Expiraci\u00F3n',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const dFechaExpiracion = rowData.row.original.dFechaExpiracion;
                //const dFaltantes = rowData.row.original.dFaltantes;
                return (dFechaExpiracion == null) ? <SoftBadge pill bg='success' className='me-2' > Sin expiraci&oacute;n</SoftBadge > :
                    <span>

                        {
                            new Date(dFechaExpiracion).toLocaleDateString('es-MX', {
                                year: 'numeric', month: 'short', day: '2-digit'
                            })
                        }

                    </span>
            }
        }

    ];
    const { token, setToken } = useToken();
    const { register, setValue, handleSubmit, formState: { errors } } = useForm();
    const { showErrorToast, showSuccessToast } = useToast();

    const [NITs, setNITs] = useState([]);
    const [planesDocumentos, setPlanesDocumentos] = useState([]);

    const [cargando, setCargando] = useState(true);
    const [cargandoDatosParaEditar, setCargandoDatosParaEditar] = useState(true);
    const [showNuevoNIT, setShowNuevoNIT] = useState(false);
    const [showEditarNIT, setShowEditarNIT] = useState(false);
    const [showModalAsignarDTE, setShowModalAsignarDTE] = useState(false);

    const [estatus, setEstatus] = useState(false);

    //Obtener UUID
    const ObtenerCadenaRandom = async (action) => {
        const response = await fetch("/api/licencia/ObtenerCadenaRandom", {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'text/plain'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.text();
            console.log(data);

            if (action == 'Usuario')
                setValue("vUsuario", data);
            else if (action == 'vPassword')
                setValue("vPassword", data);

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    //Solicita los NITs para mostrar la tabla
    const ObtenerCatalogoNITs = async () => {
        setCargando(true);
        const response = await fetch("/api/PlanesFacturacionElSalvador/ObtenerCatalogoNITs",
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const data = await response.json();
            console.log(data);

            if (data.iResponseType == 1) {

                const jsonNITs = JSON.parse(data.detalles);

                setNITs(jsonNITs);

            } else {
                showErrorToast(data.vMessage);
            }

            setCargando(false);
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    };

    //Solicita los paquetes de dte
    const ObtenerPlanesDocumentos = async (idNIT) => {
        setShowModalAsignarDTE(true);
        const response = await fetch("/api/PlanesFacturacionElSalvador/ObtenerPlanesDocumentos",
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {
                const data = JSON.parse(responseType.detalles);

                setPlanesDocumentos(data);
                setValue("idNIT", idNIT);

            } else {
                showErrorToast(responseType.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    };

    //Obtener Informacion de NIT
    const ObtenerNITByID = async (idNIT) => {
        setShowEditarNIT(true);
        setCargandoDatosParaEditar(true);
        const response = await fetch("/api/PlanesFacturacionElSalvador/ObtenerNITByID/?_Id=" + idNIT,
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {
                const data = JSON.parse(responseType.detalles);

                console.log(data);

                setValue("idElSalvadorFacturacionExistencias", data.idElSalvadorFacturacionExistencias);
                setValue("vNombre", data.vNombre);
                setValue("vNIT", data.vNIT);
                setValue("vUsuario", data.vUsuario);
                setValue("vPassword", data.vPassword);
                setValue("bIsActive", data.bIsActive);
                setEstatus(data.bIsActive);

            } else {

                showErrorToast(responseType.vMessage);
                //console.log(response);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
        setCargandoDatosParaEditar(false);
    };

    const reset = async () => {
        setValue("idElSalvadorFacturacionExistencias", "0");
        setValue("vNIT", "");
        setValue("vNombre", "");
        setValue("vUsuario", "");
        setValue("vPassword", "");
        setValue("idNIT", "");
        setValue("bIsActive", true);
        setEstatus(true);
    }

    //Registar NIT 
    const GuardarNIT = async (values) => {
        console.log(values);
        const response = await fetch("/api/PlanesFacturacionElSalvador/GuardarNIT/?jsonNIT=" + encodeURIComponent(values), {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {

            const data = await response.json();
            console.log(data);

            if (data.iResponseType == 1) {
                showSuccessToast(data.vMessage);

                setShowNuevoNIT(false);
                setShowEditarNIT(false);
                reset();

                ObtenerCatalogoNITs();
            }
            else {
                showErrorToast(data.vMessage);

            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }

        }


        /* Reiniciando */

    };

    //Asingar Paquete de DTE's' 
    const AsignarPaqueteDTE = async (_idPlan, _idNIT) => {
        setShowModalAsignarDTE(false);
        setPlanesDocumentos([]);
        const response = await fetch("/api/PlanesFacturacionElSalvador/AsignarPlanANIT/?_idPlan=" + _idPlan + "&_idNIT=" + _idNIT + "", {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {

            const data = await response.json();
            console.log(data);

            if (data.iResponseType == 1) {

                showSuccessToast(data.vMessage);

            }
            else {

                showErrorToast(data.vMessage);
            }

            ObtenerCatalogoNITs();
        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);

            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }

        }
    };

    useEffect(() => {
        ObtenerCatalogoNITs();
    }, []);

    const onSubmitNuevoNIT = data => {

        GuardarNIT(JSON.stringify(data));
        console.log(JSON.stringify(data));

    };

    const onSubmitEditarNIT = data => {
        console.log(JSON.stringify(data));
        GuardarNIT(JSON.stringify(data));
    };

    const onSubmitAsignarDTE = data => {
        AsignarPaqueteDTE(data.idElSalvadorPlanesFacturacion, data.idNIT);
        console.log(JSON.stringify(data));
    };

    const onCheckedChange = data => {
        console.log(data);
        console.log(data.target.checked);
        setEstatus(data.target.checked);
    };

    return (
        <>
            <PageHeader
                title="Documentos Electr&oacute;nicos Fiscales El Salvador"
                image="/img/bandera-el-salvador-48.png"
                className="mb-1"
            >
            </PageHeader>

            <AdvanceTableWrapper
                columns={columnsNITs}
                data={NITs}
                sortable
                pagination
                perPage={15}
            >
                <Card className="mb-3">
                    <Card.Header>
                        <Row className="flex-between-center">
                            <Col xs={4} sm="auto" className="d-flex align-items-center pe-0">
                                <div id="orders-actions">

                                    <IconButton
                                        onClick={() => { reset(); setShowNuevoNIT(true); }}
                                        variant="falcon-default"
                                        size="sm"
                                        icon="plus"
                                        transform="shrink-3">
                                        <span className="d-none d-sm-inline-block ms-1" >Nuevo NIT</span>
                                    </IconButton>


                                </div>
                            </Col>
                            <Col xs={6} sm="auto" className="ms-auto ps-0">
                                {!cargando &&
                                    <AdvanceTableSearchBox table />
                                }
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body className="p-0">
                        <AdvanceTable
                            table
                            headerClassName="bg-200 text-900 text-nowrap align-middle"
                            rowClassName="align-middle white-space-nowrap"
                            tableProps={{
                                size: 'sm',
                                striped: true,
                                hover: true,
                                className: 'fs--2 mb-0 overflow-hidden'
                            }}
                        />

                    </Card.Body>
                    <Card.Footer>

                        <AdvanceTableFooter
                            rowCount={NITs.length}
                            table
                            rowInfo
                            navButtons
                            rowsPerPageSelection
                        />
                    </Card.Footer>
                </Card>

            </AdvanceTableWrapper>
            {cargando && (<h3><Spinner className="text-inline" animation="border" variant="primary" /> Cargando...</h3>)}
            {showNuevoNIT &&
                <Modal
                    show={showNuevoNIT}
                    onHide={() => { setShowNuevoNIT(false); reset() }}
                    size="md"
                    backdrop="static"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Form noValidate onSubmit={handleSubmit(onSubmitNuevoNIT)}>
                        <Modal.Header>
                            <Modal.Title>Registra nuevo NIT</Modal.Title>
                            <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setShowNuevoNIT(false); reset() }} />

                        </Modal.Header>
                        <Modal.Body>
                            <p>Registra un nuevo NIT, de acuerdo a los lineamientos dictados por la Dirección General de Impuestos Internos (DGII).</p>

                            <Row>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>ESTATUS</Form.Label>
                                        <Row>
                                            <Col md={2}>
                                                <Form.Check // prettier-ignore
                                                    {...register("bIsActive",
                                                        {

                                                        })
                                                    }
                                                    type="switch"
                                                    onChange={e => { onCheckedChange(e) }}

                                                />
                                            </Col>
                                            <Col md={10}>
                                                {estatus ?
                                                    <Col>
                                                        <img src="/img/activo.png"></img> <Badge bg="success">Activo</Badge>
                                                    </Col>
                                                    :
                                                    <Col>
                                                        <img src="/img/noactivo.png"></img> <Badge bg="danger">Desactivado</Badge>
                                                    </Col>
                                                }

                                            </Col>
                                        </Row>


                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>NIT</Form.Label>
                                        <Form.Control

                                            isInvalid={!!errors.vNIT}
                                            {...register("vNIT",
                                                {
                                                    required: 'El NIT es requerido'
                                                })
                                            }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.vNIT && errors.vNIT.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Nombre del contribuyente</Form.Label>
                                        <Form.Control
                                            onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                            isInvalid={!!errors.vNombre}
                                            {...register("vNombre",
                                                {
                                                    required: 'El Nombre es requerido',
                                                    maxLength: 200,
                                                    minLength: 1
                                                })
                                            }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.vNombre && errors.vNombre.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Usuario <IconButton
                                            className="ms-2"
                                            iconClassName="fs--2 me-1"
                                            variant="falcon-primary"
                                            size="sm"
                                            icon="circle"
                                            onClick={() => { ObtenerCadenaRandom('Usuario') }}
                                        >
                                            Generar
                                        </IconButton></Form.Label>
                                        <Form.Control
                                            onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                            isInvalid={!!errors.vUsuario}
                                            {...register("vUsuario",
                                                {
                                                    required: 'El usuario es requerido',
                                                    maxLength: 40,
                                                    minLength: 1
                                                })
                                            }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.vUsuario && errors.vUsuario.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Contrase&ntilde;a <IconButton
                                            className="ms-2"
                                            iconClassName="fs--2 me-1"
                                            variant="falcon-primary"
                                            size="sm"
                                            icon="circle"
                                            onClick={() => { ObtenerCadenaRandom('vPassword') }}
                                        >
                                            Generar
                                        </IconButton></Form.Label>
                                        <Form.Control
                                            onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                            isInvalid={!!errors.vPassword}
                                            {...register("vPassword",
                                                {
                                                    required: 'La contrase\u00F1a es requerido',
                                                    maxLength: 40,
                                                    minLength: 1
                                                })
                                            }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.vPassword && errors.vPassword.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => { setShowNuevoNIT(false); reset() }} variant='primary' >Cerrar</Button>
                            <Button type="submit" variant='success' >Registrar</Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            }
            {showEditarNIT &&
                <Modal
                    show={showEditarNIT}
                    onHide={() => setShowEditarNIT(false)}
                    size="md"
                    backdrop="static"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Form noValidate onSubmit={handleSubmit(onSubmitEditarNIT)}>
                        <Modal.Header>
                            <Modal.Title>Editar NIT</Modal.Title>
                            <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => setShowEditarNIT(false)} />

                        </Modal.Header>
                        <Modal.Body>
                            <p>En este formulario es posible editar los datos vinculados al NIT, sin embargo, el NIT no podr&aacute; ser editado.</p>
                            {cargandoDatosParaEditar ?
                                <span><Spinner className="text-inline" animation="border" variant="primary" /> Cargando...</span> :
                                <Row>
                                    <Col md={12}>
                                        <Form.Control
                                            type="hidden"
                                            isInvalid={!!errors.idElSalvadorFacturacionExistencias}
                                            {...register("idElSalvadorFacturacionExistencias")
                                            }
                                        />

                                        <Form.Group className="mb-3">
                                            <Form.Label>ESTATUS</Form.Label>
                                            <Row>
                                                <Col md={2}>
                                                    <Form.Check // prettier-ignore
                                                        {...register("bIsActive",
                                                            {

                                                            })
                                                        }
                                                        type="switch"
                                                        onChange={e => { onCheckedChange(e) }}

                                                    />
                                                </Col>
                                                <Col md={10}>
                                                    {estatus &&
                                                        <Col>
                                                            <img src="/img/activo.png"></img> <Badge bg="success">Activo</Badge>
                                                        </Col>
                                                    }

                                                    {!estatus &&
                                                        <Col>
                                                            <img src="/img/noactivo.png"></img> <Badge bg="danger">Desactivado</Badge>
                                                        </Col>
                                                    }

                                                </Col>
                                            </Row>


                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>NIT</Form.Label>
                                            <Form.Control
                                                disabled
                                                isInvalid={!!errors.vNIT}
                                                {...register("vNIT",
                                                    {
                                                        required: 'El NIT es requerido'
                                                    })
                                                }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.vNIT && errors.vNIT.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nombre del contribuyente</Form.Label>
                                            <Form.Control
                                                onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                isInvalid={!!errors.vNombre}
                                                {...register("vNombre",
                                                    {
                                                        required: 'El Nombre es requerido',
                                                        maxLength: 200,
                                                        minLength: 1
                                                    })
                                                }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.vNombre && errors.vNombre.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Usuario <IconButton
                                                className="ms-2"
                                                iconClassName="fs--2 me-1"
                                                variant="falcon-primary"
                                                size="sm"
                                                icon="circle"
                                                onClick={() => { ObtenerCadenaRandom('Usuario') }}
                                            >
                                                Generar
                                            </IconButton></Form.Label>
                                            <Form.Control
                                                onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                isInvalid={!!errors.vUsuario}
                                                {...register("vUsuario",
                                                    {
                                                        required: 'El usuario es requerido',
                                                        maxLength: 40,
                                                        minLength: 1
                                                    })
                                                }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.vUsuario && errors.vUsuario.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Contrase&ntilde;a <IconButton
                                                className="ms-2"
                                                iconClassName="fs--2 me-1"
                                                variant="falcon-primary"
                                                size="sm"
                                                icon="circle"
                                                onClick={() => { ObtenerCadenaRandom('vPassword') }}
                                            >
                                                Generar
                                            </IconButton></Form.Label>
                                            <Form.Control
                                                onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                isInvalid={!!errors.vPassword}
                                                {...register("vPassword",
                                                    {
                                                        required: 'La contrase\u00F1a es requerido',
                                                        maxLength: 40,
                                                        minLength: 1
                                                    })
                                                }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.vPassword && errors.vPassword.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            }
                        </Modal.Body>
                        <Modal.Footer>

                            <Button onClick={() => { setShowEditarNIT(false) }} variant='primary' >Cerrar</Button>
                            {!cargandoDatosParaEditar && <Button type="submit" variant='success' >Registrar</Button>}
                        </Modal.Footer>
                    </Form>
                </Modal>
            }
            {showModalAsignarDTE &&
                <Modal
                    show={showModalAsignarDTE}
                    onHide={() => setShowModalAsignarDTE(false)}
                    size="md"
                    backdrop="static"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Form noValidate onSubmit={handleSubmit(onSubmitAsignarDTE)}>
                        <Modal.Header>
                            <Modal.Title>Asingar plan</Modal.Title>
                            <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => setShowModalAsignarDTE(false)} />

                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col>
                                    Debes elegir un paquete para asignar al NIT seleccionado.
                                    <hr></hr>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Control
                                        type="hidden"
                                        isInvalid={!!errors.idNIT}
                                        {...register("idNIT")
                                        }
                                    />
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Paquete DTE's</Form.Label>
                                        <Form.Select
                                            aria-label="Default select"
                                            defaultValue=""
                                            isInvalid={!!errors.idElSalvadorPlanesFacturacion}
                                            {...register("idElSalvadorPlanesFacturacion",
                                                {
                                                    required: true
                                                })
                                            }
                                        >
                                            <option value="">Selecciona un paquete</option>
                                            {planesDocumentos.map((plan, index) => {
                                                return (<option key={index} value={plan.idElSalvadorPlanesFacturacion}>{plan.vPlanTitle} - {(plan.dCantidad == -1) ? "Ilimitados" : plan.dCantidad} DTE's - ${plan.dPlanPrice}USD</option>)
                                            })}
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.idElSalvadorPlanesFacturacion && errors.idElSalvadorPlanesFacturacion.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => { setShowModalAsignarDTE(false) }} variant='primary' >Cerrar</Button>
                            <Button type="submit" variant='success' >ASIGNAR PLAN</Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            }
        </>
    );
};

export default PlanesFacturacionElSalvador;
